import { render } from "./Main-Dashboard.vue?vue&type=template&id=64d5f8d1"
import script from "./Main-Dashboard.vue?vue&type=script&lang=js"
export * from "./Main-Dashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__